export class DialogTextModel{
  public content: string;
  public title: string;
  public type: string;
  public ok : string;
  public body : string;
  public button: string;
  public link: string;
  public target: string;
  public image: string;
  public image_alt: string;
  id: string;
  icon: string;
  dialog_popup_type?: string;
  idf?: string;
  eInvoiceEmail?: string;
  email?: string;
  subscription?: boolean;
  disclaimer?: string;


  constructor(obj:any) {
    this.content = obj && obj.content || null;
    this.title = obj && obj.title || null;
    this.type = obj && obj.type || null;
    this.ok = obj && obj.ok || 'Ja';
    this.button = obj && obj.button || 'Ja';
    this.body = obj && obj.body || null;
    this.link = obj && obj.link || null;
    this.subscription = obj && obj.subscription || false;
    this.target = obj && obj.target || null;
    this.image = obj && obj.image || null;
    this.image_alt = obj && obj.image_alt || null;
    this.id = obj && obj.id || null;
    this.icon = obj && obj.icon || null;
    this.dialog_popup_type = obj && obj.dialog_popup_type || null;
    this.image = obj && obj.image || null;
    this.image_alt = obj && obj.image_alt || null;
    this.idf = obj?.idf;
    this.eInvoiceEmail = obj?.eInvoiceEmail;
    this.email = obj?.email;
    this.subscription = obj?.subscription;
    this.disclaimer = obj?.disclaimer;
  }
}
